<template>
  <Preview />
</template>

<script>
import Preview from '../components/pratiche/PreviewSospensioniRiattivazioni.vue'

export default {
  pageName: 'Preview',
  components: {
    Preview
  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>
